module.exports = __webpack_public_path__ + "static/media/80 - George Michael - Freedom '90 (Remastered).bbaa4504.mp3";